var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "addon-modal-page",
      class: !_vm.showModal ? "collapsed" : "",
      on: { click: _vm.closeModal }
    },
    [
      _vm.selectedAddon
        ? _c(
            "div",
            {
              ref: "addonModal",
              staticClass: "addon-modal-container",
              class: !_vm.showModal ? "collapsed" : "",
              attrs: { id: "addonModal" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "empty-space",
                  on: { touchstart: _vm.dragStart, touchend: _vm.dragEnd }
                },
                [
                  _c("img", {
                    staticClass: "x",
                    attrs: {
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
                      alt: "x"
                    },
                    on: { click: _vm.closeModal }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "addon-container" }, [
                _vm.selectedAddon.images.length < 2
                  ? _c("div", { staticClass: "images-container" }, [
                      _vm.mainBadge != null
                        ? _c("span", { staticClass: "main-badge" }, [
                            _vm._v(_vm._s(_vm.mainBadge))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "main-image",
                        attrs: { src: _vm.currentMainImage }
                      })
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "images-container",
                        attrs: { id: "images-carousel" }
                      },
                      [
                        _vm.mainBadge != null
                          ? _c("span", { staticClass: "main-badge" }, [
                              _vm._v(_vm._s(_vm.mainBadge))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "VueSlickCarousel",
                          {
                            attrs: {
                              infinite: true,
                              dots: true,
                              arrows: true,
                              slidesToShow: 1,
                              slidesToScroll: 1
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "prevArrow",
                                  fn: function(arrowOption) {
                                    return [
                                      _c("div", [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_left.svg?v=1657408648"
                                          }
                                        })
                                      ])
                                    ]
                                  }
                                },
                                {
                                  key: "nextArrow",
                                  fn: function(arrowOption) {
                                    return [
                                      _c("div", [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_right.svg?v=1657408648"
                                          }
                                        })
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              619622916
                            )
                          },
                          [
                            _vm._v(" "),
                            _vm._l(_vm.selectedAddon.images, function(image) {
                              return _c("div", { key: image.id }, [
                                _c("img", {
                                  staticClass: "main-image",
                                  attrs: { src: image.src }
                                })
                              ])
                            })
                          ],
                          2
                        )
                      ],
                      1
                    ),
                _vm._v(" "),
                _c("div", { staticClass: "data-container" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.selectedAddon.title))
                  ]),
                  _vm._v(" "),
                  _vm.hasVariants
                    ? _c("div", { staticClass: "variant-container" }, [
                        _c("p", { staticClass: "variant-title" }, [
                          _vm._v(
                            _vm._s(this.selectedAddon.options[0].name) + ":"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "variants-button-container" },
                          _vm._l(this.selectedAddon.variants, function(
                            variant,
                            i
                          ) {
                            return _c(
                              "button",
                              {
                                key: variant.id,
                                class:
                                  _vm.selectedVariant == i ? "selected" : "",
                                on: {
                                  click: function($event) {
                                    return _vm.selectVariant(i)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(variant.title.slice(0, 1)) +
                                    "\n                            "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ethosTags.length > 0 || _vm.showOnDemand
                    ? _c(
                        "div",
                        { staticClass: "ethos-container" },
                        [
                          _vm._l(_vm.ethosTags, function(etho) {
                            return _c(
                              "span",
                              { key: etho, class: _vm.badgeExtraClass(etho) },
                              [_vm._v(_vm._s(etho))]
                            )
                          }),
                          _vm._v(" "),
                          _vm.showOnDemand
                            ? _c("span", { staticClass: "purple-ethos" }, [
                                _vm._v("Ships in 1-2 weeks")
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc-label" }, [
                    _vm._v("Description")
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "desc",
                    domProps: { innerHTML: _vm._s(_vm.productDesc) }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "alergen-container" },
                    _vm._l(_vm.dietaryTags, function(dietary) {
                      return _c("span", { key: dietary }, [
                        _vm._v(_vm._s(dietary))
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.allergens
                    ? _c("div", { staticClass: "ingredient-container" }, [
                        _c("p", [
                          _c("strong", [_vm._v("ALLERGENS:")]),
                          _vm._v(" " + _vm._s(_vm.allergens))
                        ])
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "recommendation-container" }, [
                _c("p", { staticClass: "title" }, [_vm._v("Add more gifts:")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "recommended-addons-container no-scrollbar" },
                  _vm._l(_vm.recommendedAddons, function(addon) {
                    return _c(
                      "div",
                      { key: addon.id, staticClass: "recommended-addon" },
                      [
                        _c("img", {
                          staticClass: "main-image",
                          attrs: { src: addon.image.src },
                          on: {
                            click: function($event) {
                              return _vm.changeAddon(addon)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "happybox-button white border",
                            on: {
                              click: function($event) {
                                return _vm.updateReccomendedAddonProductQuantity(
                                  addon
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.addCopy))]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "addon-title" }, [
                          _vm._v(_vm._s(addon.title))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "price" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moneySaleFormat")(addon.variants[0].price)
                            )
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _vm.showModal
                ? _c("div", { staticClass: "add-addon-container" }, [
                    _vm.customAlert != ""
                      ? _c("p", {
                          staticClass: "red-alert",
                          domProps: { innerHTML: _vm._s(_vm.customAlert) },
                          on: { click: _vm.changeMinBoxQty }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.currentQty == 0,
                            expression: "currentQty == 0"
                          }
                        ],
                        staticClass: "happybox-button green border",
                        attrs: { disabled: !_vm.canAddMore },
                        on: {
                          click: function($event) {
                            return _vm.updateMainAddonProductQuantity(1)
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.addCopy) +
                            " - " +
                            _vm._s(_vm._f("moneySaleFormat")(_vm.productPrice))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.currentQty > 0,
                            expression: "currentQty > 0"
                          }
                        ],
                        staticClass: "quantity-container",
                        class: !_vm.canAddMore ? "no-more" : ""
                      },
                      [
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.updateProductQuantity(false)
                              }
                            }
                          },
                          [_vm._v("-")]
                        ),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.currentQty) + " in box")]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content: _vm.limitMessage,
                                  container: false
                                },
                                expression:
                                  "{content: limitMessage, container: false}"
                              }
                            ],
                            class: _vm.canAddMore ? "disabled" : "",
                            on: {
                              click: function($event) {
                                return _vm.updateProductQuantity(true)
                              }
                            }
                          },
                          [_vm._v("+")]
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }